import React, { useState } from "react";
import "../../styles/ChecklistCard.css";
import ChecklistCard from "../../components/ChecklistCard.js";
import { createTheme, ThemeProvider } from "@mui/material/styles";
import FormControl from "@mui/material/FormControl";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import importantNotes from "../../data/Alberta/importantNotes.js";
import ImportantNotes from "../../components/ImportantNotes.js";

export default function Referral() {
  const theme = createTheme({
    palette: {
      primary: {
        main: "#506CAA",
        dark: "#506CAA",
      },
      text: {
        primary: "#31303F",
        secondary: "#506CAA",
      },
    },
  });

  const PreConReferralData = [
    "Builder Broker Referral Agreement (Builder Registration)",
  ];

  const ReferralData = [
    "Referral Fee Consent",

    "Referral Commission Agreement",
  ];

  const handleReferralType = (e) => {
    setReferralType(e.target.value);
  };

  const [ReferralType, setReferralType] = useState(
    "Referral of Client to another Agent"
  );

  return (
    <div className="checklists w-full flex flex-col items-center justify-center">
      <div className="flex flex-col w-full pl-4 ">
        <div className="flex flex-col items-left pb-2">
          <div className="pr-5 ">Referral Type?</div>
          <ThemeProvider theme={theme}>
            <FormControl>
              <RadioGroup
                row
                aria-labelledby="demo-row-radio-buttons-group-label"
                name="row-radio-buttons-group"
                defaultValue="Referral of Client to another Agent"
              >
                <FormControlLabel
                  value="Referral of Client to another Agent"
                  control={<Radio size="small" onClick={handleReferralType} />}
                  label="Referral of Client to another Agent"
                />

                <FormControlLabel
                  value="Referral of Client to You"
                  control={<Radio size="small" onClick={handleReferralType} />}
                  label="Referral of Client to You"
                />
                <FormControlLabel
                  value="Referral to Builder"
                  control={<Radio size="small" onClick={handleReferralType} />}
                  label="Referral to Builder"
                />
                <FormControlLabel
                  value="Referral to 3rd Party"
                  control={<Radio size="small" onClick={handleReferralType} />}
                  label="Referral to 3rd Party (ie. Mortgage Broker)"
                />
              </RadioGroup>
            </FormControl>
          </ThemeProvider>
        </div>
        <div></div>
      </div>
      {ReferralType === "Referral of Client to another Agent" ? (
        <ChecklistCard
          CheckListData={[
            "Added to Deal Sheet of SkySlope Transaction File",
            "Referral Commission Agreement",
            "Do not create new SkySlope Transaction",
          ]}
          CheckListData2={ReferralData}
          Header={"Referral"}
          Title1="Referral Documents (eXp Agent in Alberta)"
          Title2="Referral Documents (Outside Brokerage Agent or Outside Alberta)"
          province={"AB"}
        />
      ) : (
        ""
      )}
      {ReferralType === "Referral of Client to You" ? (
        <ChecklistCard
          CheckListData={[
            "All Transaction Documents as Listed in Purchase Section",
            "Add Agent to the Deal Sheet as a Referral",
          ]}
          CheckListData2={[
            "All Transaction Documents as Listed in Purchase Section",
            "Add Agent to the Deal Sheet as a Referral",
          ]}
          CheckListData3={[
            "All Transaction Documents as Listed in Purchase Section",
            "Lead Referral - From Unlicensed Person",
            "Void Cheque from Unlicensed Person",
            "Add Unlicensed Person to the Deal Sheet as a Referral",
          ]}
          Header={"Referral"}
          Title1="Referred from an eXp Agent in Alberta"
          Title2="Referral Documents (Outside Brokerage Agent)"
          Title3="Referral From an Unlicensed Person"
          province={"AB"}
        />
      ) : (
        ""
      )}
      {ReferralType === "Referral to Builder" ? (
        <ChecklistCard
          Title1={""}
          CheckListData={PreConReferralData}
          Header={"Referral of Client to Builder"}
          Header2={""}
          province={"AB"}
        />
      ) : (
        ""
      )}
      {ReferralType === "Referral to 3rd Party" ? (
        <ChecklistCard
          Title1={""}
          CheckListData={[
            "Referral Fee Consent",

            "Referral Commission Agreement",
          ]}
          Header={"Referral of Client to 3rd Party"}
          Header2={""}
          province={"AB"}
        />
      ) : (
        ""
      )}
      <div className="important-notes flex flex-col w-full justify-left pt-6">
        <strong className="pb-3">Important Notes:</strong>

        <ImportantNotes
          Notes={importantNotes.filter(
            (notes) => notes.category.includes("referral") === true
          )}
        />
      </div>
    </div>
  );
}
